import {AxiosError} from 'axios'
import React, {useCallback, useEffect, useState} from 'react'
import {DeviceListGroup} from '../../../modules/auth/core/_requests'
import DeviceGroupsPost from '../Posts/DeviceGroupsPost'

function TabContentTableGroup({
  searchTerm,
  checkedControl,
  handleChecked,
  id,
  action,
  setEditData,
}: any) {
  const [deviceGroup, setDeviceGroup] = useState([])

  useEffect(() => {
    if (id) {
      getDeviceGroupList()
    }
  }, [id])

  useEffect(() => {
    if (action && id) {
      getDeviceGroupList()
    }
  }, [action])

  const getDeviceGroupList = async () => {
    try {
      const {data} = await DeviceListGroup(id)
      setDeviceGroup(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const keys = ['groupsName', 'groupsDescription']

  const deviceList = deviceGroup || []

  const search = () => {
    if (searchTerm) {
      return deviceList.filter((item: any) =>
        keys.some((key) => item[key].toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))
      )
    } else {
      return deviceList
    }
  }

  if (action) {
    return (
      <div className='d-flex flex-column-fluid flex-center'>
        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
      </div>
    )
  }

  return (
    <table className='table table-striped gy-7 gs-7'>
      <thead>
        <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200  '>
          <th className='w-50px'>#</th>
          <th>Name</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <DeviceGroupsPost
          search={search}
          list={deviceList}
          checkedControl={checkedControl}
          handleChecked={handleChecked}
          setEditData={setEditData}
        />
      </tbody>
    </table>
  )
}

export default TabContentTableGroup
